<template>
  <div class="l-container">
    <div class=" grid-rows-7 gap-y-7 mb-8">
      <!-- img header -->
      <div>
        <img :src="image_header" @click="handleBanner()" class="img-banner" />
      </div>
      <!-- Order field -->
      <!-- Order-PC -->
      <div class="order">
        <div class="p-8">
          <div class="header">
            <div>
              <p>会員ID：{{ userId }}</p>
              <p class="font-semibold text-base">{{ fullName }} 様</p>
              <p>{{ email }}</p>
            </div>
            <div class="logout-field">
              <i class="icon icon-bor-logout mr-2 text-lg" />
              <span>ログアウト</span>
            </div>
          </div>

          <div class="menu_item flex justify-between">
            <ItemBox
              :menu_item="item"
              v-for="(item, index) in menu_item"
              :key="index"
              @gotoPath="gotoPath(item.path)"
            />
          </div>
          <!-- bill-PC -->
          <div class="bill">
            <div class="col-span-1">
              <p class="font-semibold text-xl text-gray-500">ベネポ</p>
            </div>
            <div class="col-span-3">
              <div class="grid grid-cols-12">
                <div class="col-span-10">
                  <div class="flex justify-between">
                    <p class="text-base font-semibold">総保有ベネポ</p>
                    <p class="text-3xl font-semibold">
                      {{ totalPoint | formatInteger }}
                    </p>
                  </div>
                  <div class="flex justify-between">
                    <p>今月末に無効になるベネポ</p>
                    <p>
                      {{ totalPointValidOfMonth | formatInteger }}
                    </p>
                  </div>
                  <a-divider />
                  <div class="flex justify-between">
                    <p class="text-base font-semibold">獲得予定ベネポ</p>
                    <p class="text-2xl font-semibold">
                      {{ grantedPoint | formatInteger }}
                    </p>
                  </div>
                </div>
                <div class="flex items-center col-span-2">
                  <div class="text-right w-full cursor-pointer" @click="gotoNextPath('/mypage/benepo-history')" >
                    <i class="icon icon-bor-arrow-right text-red-400"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- discount-PC -->
        <!-- <div class="p-8 border-t"> -->
          <!-- <div class="discount">
            <p class="font-semibold text-gray-500">
              所属団体様専用補助クーポン
            </p>
            <div class="grid grid-cols-12 pt-4 data-table">
              <div class="col-span-11 ml-8">
                <div
                  class="grid grid-cols-12 mt-2 text-center"
                  v-for="(item, index) in 2"
                  :key="index"
                >
                  <div class="col-span-2">
                    <p class="font-bold w-full">映画補助</p>
                  </div>
                  <div class="col-span-8 grid grid-cols-4">
                    <div class="col-span-2">
                      <p class="label label-grey-200 mr-3">有効期限</p>
                      <span>2021/00/00</span>
                    </div>
                    <div>
                      <p class="label label-grey-200 mr-3">保有枚数</p>
                      <span>1枚500円</span>
                    </div>
                    <div>
                      <span>残り○枚</span>
                    </div>
                  </div>
                  <div class="col-span-2">
                    <p class="font-bold text-lg">3,500円分</p>
                  </div>
                </div>
              </div>

              <div class="col-span-1">
                <div class="text-right">
                  <i class="icon icon-bor-arrow-right text-red-400"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->

      </div>
      <!-- Order-Mobile -->
      <div class="order-mb">
        <div class="p-5">
          <div class="header">
            <div>
              <p>会員ID：{{ order.header.ID }}</p>
              <p class="font-semibold text-lg">{{ order.header.title }}</p>
              <p>{{ order.header.sub_title }}</p>
            </div>
          </div>

          <div class="menu_item">
            <ItemBox
              :menu_item="item"
              v-for="(item, index) in menu_item"
              :key="index"
            />
          </div>
          <!-- bill-Mobile -->
          <div class="bill">
            <div class="flex justify-between">
              <p class="font-semibold text-base text-gray-500">ベネポ</p>
              <i class="icon icon-bor-arrow-right text-red-400"></i>
            </div>
            <div class="flex justify-between mt-3">
              <p class="text-base font-semibold">総保有ベネポ</p>
              <p class="text-3xl font-semibold">
                {{ totalPoint | formatInteger }}
              </p>
            </div>
            <div class="flex justify-between">
              <p>今月末に無効になるベネポ</p>
              <p>{{ totalPointValidOfMonth | formatInteger }}</p>
            </div>
            <a-divider />
            <div class="flex justify-between">
              <p class="text-base font-semibold">獲得予定ベネポ</p>
              <p class="text-2xl font-semibold">{{ grantedPoint | formatInteger }}</p>
            </div>
          </div>
        </div>

        <!-- <div class="p-5 border-t"> -->
          <!-- <div class="discount"> -->
            <!-- <div class="flex justify-between"> -->
              <!-- <p class="font-semibold text-gray-500"> -->
                <!-- 所属団体様専用補助クーポン -->
              <!-- </p> -->
              <!-- <i class="icon icon-bor-arrow-right text-red-400"></i> -->
            <!-- </div> -->
            <!-- <div -->
              <!-- v-for="(item, index) in 2" -->
              <!-- :key="index" -->
              <!-- :class="[{ 'border-b': index != 1 }, 'pb-2']" -->
            <!-- > -->
              <!-- <div class="flex justify-between mt-5"> -->
                <!-- <p class="font-bold">映画補助</p> -->
                <!-- <p class="font-bold text-xl">3,500円分</p> -->
              <!-- </div> -->
              <!-- <div class="flex justify-around mt-1"> -->
                <!-- <p class="label label-grey-200 mr-1 p-1">有効期限</p> -->
                <!-- <span>2021/00/00</span> -->
                <!-- <p class="label label-grey-200 mr-1 p-1">保有枚数</p> -->
                <!-- <span>1枚500円</span> -->
                <!-- <span>残り○枚</span> -->
              <!-- </div> -->
            <!-- </div> -->
          <!-- </div> -->
        <!-- </div> -->

        <div class="logout-field ">
          <i class="icon icon-bor-logout  mr-2 text-lg" />
          <span>ログアウト</span>
        </div>
      </div>
      <!-- List product -->
      <div class="list-product">
        <!-- <section class="p-0"> -->
          <!-- <SectionContentTitle -->
            <!-- :lineType="lineType.horizontal" -->
            <!-- :titleContent="myCoupons.subTitle" -->
          <!-- /> -->
          <!-- <div class="mycoupon"> -->
            <!-- <RecommendedItemLarge -->
              <!-- :recommendedData="item" -->
              <!-- v-for="(item, index) in myCoupons.data.slice(0,3)" -->
              <!-- :key="index" -->
            <!-- /> -->
          <!-- </div> -->
          <!-- <Seemore :seemoreData="myCoupons.seemore" class="mt-4" /> -->
        <!-- </section> -->
        <!-- Other Product -->
        
        <!-- LIST FAVORTIR -->
        <section v-if="status != 'CC'"
          class="field-recommendItem p-0">
          <SectionContentTitle
            :lineType="lineType.horizontal"
            :titleContent="favoriteData.subTitle"
          />
          <div class="other-product-data" v-if="favoriteData.data && favoriteData.data.length > 0">
            <RecommendedItem
              :recommendedData="item"
              v-for="(item, index) in favoriteData.data.slice(0,4)"
              :key="index"
              @handleNext="gotoNextPath('bs-02-001', { menuNo: item.seriesNumber })"
            />
          </div>
          <div class="field-recommendItem__notif-err " v-else>
            <span>誠に申し訳ございませんが、データがありませんでした</span> 
          </div>
          <Seemore :seemoreData="favoriteData.seemore" class="mt-4" />
        </section>

        <!-- LIST HISTORY -->
        <section
          class="field-recommendItem p-0">
          <SectionContentTitle
            :lineType="lineType.horizontal"
            :titleContent="viewedHistoryList.subTitle"
          />
          <div class="other-product-data" v-if="viewedHistoryList.data && viewedHistoryList.data.length > 0">
            <RecommendedItem
              :recommendedData="item"
              v-for="(item, index) in viewedHistoryList.data.slice(0,4)"
              :key="index"
              @handleNext="gotoNextPath('bs-02-001', { menuNo: item.seriesNumber })"
            />
          </div>
          <div class="field-recommendItem__notif-err " v-else>
            <span>誠に申し訳ございませんが、データがありませんでした.</span> 
          </div>
          <Seemore :seemoreData="viewedHistoryList.seemore" class="mt-4" />
        </section>

        <!-- HISTORY Order -->
        <section
          class="field-recommendItem p-0">
          <SectionContentTitle
            :lineType="lineType.horizontal"
            :titleContent="orderHistoryList.subTitle"
          />
          <div class="other-product-data" v-if="orderHistoryList.data && orderHistoryList.data.length > 0">
            <RecommendedItem
              :recommendedData="item"
              v-for="(item, index) in orderHistoryList.data.slice(0,4)"
              :key="index"
              @handleNext="gotoNextPath('/mypage/orders', { acptNo: item.seriesNumber })"
            />
          </div>
          <div class="field-recommendItem__notif-err " v-else>
            <span>誠に申し訳ございませんが、データがありませんでした.</span> 
          </div>        
       <Seemore :seemoreData="orderHistoryList.seemore" class="mt-4" />
        </section>

        <!-- CRM汎用独自対応↓↓↓ -->
        <!-- <div class="hidden wovn-languages" data-ready="key=S_MzJf&ready=true" data-theme="build-in"> 
          <ul class="wovn-lang-list"> 
            <li class="wovn-switch selected" data-value="en">English</li> 
            <li class="wovn-switch" data-value="ja">日本語</li> 
          </ul> 
        </div> -->
        <!-- CRM汎用独自対応↑↑↑ -->
      </div>
      <!--// End List product -->
    </div>
  </div>
</template>

<script>
import {
  ItemBox,
  SectionContentTitle
} from '@/components/compound'
// import RecommendedItemLarge from './components/RecommendedItemLarge'
import RecommendedItem from './components/RecommendedItem'
import Seemore from './components/Seemore'
import { GET_PROFILE, GET_MY_COUPON } from '@/store/modules/bs_app/actions'
import { GET_FAVORITE_LIST, GET_ORDERS_HISTORY, GET_POINT_HISTORY } from '@/store/modules/bs_myp/actions'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import moment from 'moment'
import _ from 'lodash'
import { getCookieValue } from '@/utils/cookie'

export default {
  name: 'BS_MYP_01_001',
  props: {},
  components: {
    RecommendedItem,
    SectionContentTitle,
    ItemBox,
    // RecommendedItemLarge,
    Seemore
  },
  data() {
    return {
      userId: null,
      fullName: null,
      email: null,
      totalPoint: null,
      grantedPoint: null,
      totalPointValidOfMonth: 0, 
      image_header: require('@/assets/images/mypage/house-header.jpg'),
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      favoriteList: null,
      popupLogin: false,
      totalResultsFavorite: null,
      params: {
        itemType: 'favourite',
        page: 0, 
        size: 10
      },
      params1: {
        itemType: 'viewed',
        page: 0, 
        size: 10
      },
      dataCat: {
        catLrgClassNm: null,
        catMidClassNm: null,
        catSmlClassNm: null
      },
      order: {
        header: {
          ID: 'xxxxxx@xxxxx',
          title: 'ベネフィット太郎 様（氏名）',
          sub_title: 'コーギー大好き（ニックネーム）'
        },
        body: {
          total_benepo: 600,
          benepo_near_expiry: 50,
          earn_benepo: 100
        },
        footer: {}
      },
      menu_item: [
        {
          icon: 'icon icon-bor-coupon',
          name: 'クーポン',
          path: '/mypage/bs-myp-02-001'
        },
        {
          icon: 'icon icon-bor-heart',
          name: 'お気に入り',
          path: '/mypage/favorites'
        },
        {
          icon: 'icon icon-bor-clock-undo',
          name: '閲覧履歴',
          path: '/mypage/visits'
        },
        {
          icon: 'icon icon-bor-shopping-cart-time',
          name: '申込履歴',
          path: '/mypage/orders'
        },
        {
          icon: 'icon icon-bor-take-note',
          name: 'クチコミ',
          path: '/mypage/bs-myp-06-001'
        },
        {
          icon: 'icon icon-bor-user',
          name: '会員設定',
          path: '/mypage/setting'
        }
      ],
      icon: {
        logout: require('@/assets/images/mypage/logout.png'),
        right_arrow: require('@/assets/images/mypage/right_arrow.png')
      },
      myCoupons: {
        subTitle: 'マイクーポン',
        data: [],
        seemore: [
          {
            name: 'マイクーポン一覧を見る',
            path: '/mypage/bs-myp-02-001'
          }
          
        ]
      },
      favoriteData: {
        subTitle: 'お気に入りメニュー',
        data: [],
        seemore: [
          {
            name: 'お気に入りメニューを見る',
            path: '/mypage/favorites'
          },
          {
            name: 'Wishリストを見る',
            path: 'by-myp-04-002'
          }
        ]
      },
      viewedHistoryList: {
        subTitle: '閲覧履歴',
        data: [],
        seemore: [
          {
            name: '閲覧履歴を見る',
            path: '/mypage/visits'
          }
        ]
      },
      orderHistoryList: {
        subTitle: 'お申し込み履歴',
        data: [],
        seemore: [
          {
            name: '利用履歴を見る',
            path: '/mypage/orders'
          }
        ]
      },
      breadcrumb_data: ['トップ', 'マイページ'],
      status: null
    }
  },
  mounted () {
    if (this.loggedIn) {
      this.getMenuItem()
      this.getProfileInfo()
      this.getMyCoupon()
      this.getFavoriteList(this.params)
      this.getPointHistory()
      const breadcrumbs = [
        { title: 'トップ', path: '/' },
        { title: 'マイページ', path: '' }
      ]
      this.$store.dispatch(BREADCRUMBS, breadcrumbs)
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({path: '/', query: params})
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    },
    getCatNm() {
      const dataCatNm = this.dataCat
    
      if(!dataCatNm.catLrgClassNm && !dataCatNm.catMidClassNm && dataCatNm.catSmlClassNm) {
        return `${dataCatNm.catSmlClassNm}`
      }
      if(!dataCatNm.catLrgClassNm && dataCatNm.catMidClassNm && !dataCatNm.catSmlClassNm) {
        return `${ dataCatNm.catMidClassNm}`
      }
      if(dataCatNm.catLrgClassNm && !dataCatNm.catMidClassNm && dataCatNm.catSmlClassNm) {
        return `${ dataCatNm.catLrgClassNm}`
      }
      if(!dataCatNm.catLrgClassNm && dataCatNm.catMidClassNm && dataCatNm.catSmlClassNm) {
        return `${dataCatNm.catMidClassNm  }・${ dataCatNm.catSmlClassNm}`
      }
      if(dataCatNm.catLrgClassNm && !dataCatNm.catMidClassNm && dataCatNm.catSmlClassNm) {
        return `${dataCatNm.catLrgClassNm  }・${ dataCatNm.catSmlClassNm}`
      }
      if(dataCatNm.catLrgClassNm && dataCatNm.catMidClassNm && !dataCatNm.catSmlClassNm) {
        return `${dataCatNm.catLrgClassNm  }・${ dataCatNm.catMidClassNm}`
      }
      if(dataCatNm.catLrgClassNm && dataCatNm.catMidClassNm && dataCatNm.catSmlClassNm) {
        return `${dataCatNm.catLrgClassNm  }・${  dataCatNm.catMidClassNm  }・${ dataCatNm.catSmlClassNm}`
      }
      return null
    }
  },
  methods: {
    getProfileInfo () {
      this.$store.dispatch(GET_PROFILE).then((data) => {
        if(data !== null) {
          if(data) {
            this.profileInfo = data
            this.userId = _.get(data, 'email', null)
            this.fullName = `${_.get(data, 'familyName', '')} ${_.get(data, 'firstName', '')}`
            this.email = ''
          }
        }
      })
    },
    getMyCoupon() {
      this.$store.dispatch(GET_MY_COUPON).then((data) => {
        if(data !== null) {
          for(let i = 0; i < data.dataList.length; i++) {
            const dataMyCoupon = {} 
            dataMyCoupon.seriesNumber = _.get(data.dataList[i], 'menuNo', '')
            dataMyCoupon.name = _.get(data.dataList[i], 'menuNm', '')
            dataMyCoupon.img  = _.get(data.dataList[i], 'imageURL', '')
            dataMyCoupon.category = _.get(data.dataList[i], 'menuNm', '')
            dataMyCoupon.discount = _.get(data.dataList[i], 'planNm', '')
            dataMyCoupon.expireTo = _.get(data.dataList[i], 'expireTo', '')
            this.myCoupons.data.push(dataMyCoupon)
          }
        }
      })
    },
    getFavoriteList(params) {
      params.page = this.page - 1
      if (params.page === -1) {
        this.params.page = 0
      }
      this.$store.dispatch(GET_FAVORITE_LIST, params).then((data) => {
        if(data !== null) {
          this.favoriteList = []
          data.content.map(item => {
            return {
              id: item.id,
              ...JSON.parse(item.menuDetailResponse)
            }
          }).forEach(content => {
            const favorite = {}
            favorite.img = _.get(content, 'menuImages[0].imageUrl', '')
            favorite.seriesNumber = _.get(content, 'menuNo', '')
            favorite.name = _.get(content, 'menuNm', '')
            const catLrgClassNm = _.get(content, 'categoryInfomation.catLrgClassNm', null)
            const catMidClassNm = _.get(content, 'categoryInfomation.catMidClassNm', null)
            const catSmlClassNm = _.get(content, 'categoryInfomation.catSmlClassNm', null)
            this.dataCat = {
              catLrgClassNm,
              catMidClassNm,
              catSmlClassNm
            }
            favorite.category = this.getCatNm
            this.favoriteData.data.push(favorite)
          
          })
        }
        this.getViewedHistoryList(this.params1)
      })
    },
    getViewedHistoryList(params) {
      params.page = this.page - 1
      if (params.page === -1) {
        this.params.page = 0
      }
      this.$store.dispatch(GET_FAVORITE_LIST, params).then((data) => {
        if(data !== null) {
          this.favoriteList = []
          data.content.map(item => {
            return {
              id: item.id,
              ...JSON.parse(item.menuDetailResponse)
            }
          }).forEach(content => {
            const viewedHistory = {}
            viewedHistory.img = _.get(content, 'menuImages[0].imageUrl', '')
            viewedHistory.seriesNumber = _.get(content, 'menuNo', '')
            viewedHistory.name = _.get(content, 'menuNm', '')
            const catLrgClassNm = _.get(content, 'categoryInfomation.catLrgClassNm', null)
            const catMidClassNm = _.get(content, 'categoryInfomation.catMidClassNm', null)
            const catSmlClassNm = _.get(content, 'categoryInfomation.catSmlClassNm', null)
            this.dataCat = {
              catLrgClassNm,
              catMidClassNm,
              catSmlClassNm
            }
            viewedHistory.category = this.getCatNm
            this.viewedHistoryList.data.push(viewedHistory)
          })
        }
        this.getOrderListHistory()
      })
    },
    getOrderListHistory() {
      const params = {
        menuNm: '',
        startIndex: 0,
        count: 10,
        reserveSts: 0
      }
      this.$store.dispatch(GET_ORDERS_HISTORY, params).then((data) => {
        const orderInfo = _.get(data, 'orderInfoList', null)
        if(orderInfo) {
          orderInfo.forEach(item => {
            const order = {}
            order.img = _.get(item, 'menuInfo.menuImages[0].imageUrl', '')
            order.seriesNumber = _.get(item, 'menuNo', '')
            order.name = _.get(item, 'menuNm', '')
            const catLrgClassNm = _.get(item, 'catLrgClassCd', null)
            const catMidClassNm = _.get(item, 'catMidClassCd', null)
            const catSmlClassNm = _.get(item, 'catSmlClassCd', null)
            this.dataCat = {
              catLrgClassNm,
              catMidClassNm,
              catSmlClassNm
            }
            order.category = this.getCatNm
            this.orderHistoryList.data.push(order)
          })
        }
      })
    },
    checkValidTime(timeStr) {
      const yearOfPointHist = timeStr.substr(0, 4)
      const monthOfPointHist = timeStr.substr(4, 2)
      const dayOfPointHist = timeStr.substr(6, 2)
      const endOfMonthCurrent = moment().clone().endOf('month').format('YYYY/MM/DD')
      const datePoint = `${yearOfPointHist}/${monthOfPointHist}/${dayOfPointHist}`
      return (moment(datePoint).isSame(moment(endOfMonthCurrent), 'month'))
    },
    getPointHistory() {
      const params = {
        commandType: 1
      }
      this.$store.dispatch(GET_POINT_HISTORY, params).then((data) => {
        if(data) {
          this.totalPoint = _.get(data, 'totalPoint', null)
          this.grantedPoint =  _.get(data, 'grantedPoint', null)
          if(data.historyDataList) {
            data.historyDataList.filter(item => this.checkValidTime(item.validTo)).forEach(ele => {
              this.totalPointValidOfMonth += ele.point
            })
          }
        }
      })
    },
    gotoPath(router) {
      const query = this.$route.query
      this.$router.push({path: router, query})
    },
    gotoNextPath(path, query) {
      // const query = this.$router.query
      this.$router.push({path, query})
    },
    handleBanner() {
      const query = this.$router.query
      this.$router.push('bs-spe-01-001', query)
    },
    getMenuItem(){
      const bsjsessionid = getCookieValue(process.env.VUE_APP_SSO_COOKIE_NAME);
      this.status = bsjsessionid.slice(0, 2);
      if(this.status != null && this.status == "CC")
      this.menu_item.splice(1,1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./style.scss";
</style>
